exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/liyankai/Documents/github/seiya_web.git/src/app/shared/upload-simple/upload-simple.component.css
// module id = ../../../../../src/app/shared/upload-simple/upload-simple.component.css
// module chunks = main